import { Pipe, PipeTransform } from '@angular/core';

const PERSONA_ICON = {
  1: 'consignee-icon', //Consignee
  2: 'iso-tank-depot-icon', //ISO Tank Depot
  3: 'logistics-service-provider-icon', //Logistics Service Provider
  4: 'port-icon', //Port
  5: 'railhead-icon', //Railhead
  6: 'shipper-icon', //Shipper
  7: 'shipping-line-icon', //Shipping Line
  8: 'trucking-company-icon', //Trucking Company
  10: 'agent-icon', //Agent
  11: 'bulk-storage-terminal-icon', //Agent
  // 12: 'carrier-icon'
}

@Pipe({ name: 'personaIcon' })
export class PersonaIconPipe implements PipeTransform {

  transform(value: any): any {
    let classIcon = 'persona-unknown';
    if (PERSONA_ICON[value]) {
      classIcon = PERSONA_ICON[value]
    }
    return classIcon;
  }
}
